import { useConfigStore } from "@/store/use-config-store";

/** Runtime config from config.json takes precedence; Vite env vars are dev fallbacks. */
export function getPublicEnv(key: string): string | undefined {
  const settings = useConfigStore.getState().settings;
  const map: Record<string, string | undefined> = {
    URL: settings?.selfUrl ?? import.meta.env.VITE_SELF_URL,
    BASE_PATH: settings?.basePath ?? import.meta.env.VITE_BASE_PATH ?? "/membersapp",
    SELF_URL: settings?.selfUrl ?? import.meta.env.VITE_SELF_URL,
    CUSTOMER: settings?.customer ?? import.meta.env.VITE_CUSTOMER,
    SHOP_API_URI: settings?.shopApiUri ?? import.meta.env.VITE_SHOP_API_URI,
    BOOKING_API_URI: settings?.bookingApiUri ?? import.meta.env.VITE_BOOKING_API_URI,
    MEMBERS_API_URI: settings?.membersApiUri ?? import.meta.env.VITE_MEMBERS_API_URI,
    AUTH_API_URI: settings?.authApiUri ?? import.meta.env.VITE_AUTH_API_URI,
    MONITOR_API_URI: settings?.monitorApiUri ?? import.meta.env.VITE_MONITOR_API_URI,
    CHECKOUT_URL: settings?.checkoutUrl ?? import.meta.env.VITE_CHECKOUT_URL,
    POS_ID: settings?.posId != null ? String(settings.posId) : import.meta.env.VITE_POS_ID,
    USE_BOOKING:
      settings?.useBooking != null ? String(settings.useBooking) : import.meta.env.VITE_USE_BOOKING,
    USE_COURSE: import.meta.env.VITE_USE_COURSE,
    USE_SESSION: import.meta.env.VITE_USE_SESSION,
    USE_ALLOTMENT:
      settings?.useAllotment != null
        ? String(settings.useAllotment)
        : import.meta.env.VITE_USE_ALLOTMENT,
    USE_PRODUCT: import.meta.env.VITE_USE_PRODUCT,
    USE_ARTICLE_GROUP: import.meta.env.VITE_USE_ARTICLE_GROUP,
    ENVIRONMENT: settings?.environment ?? import.meta.env.VITE_ENVIRONMENT
  };
  return map[key];
}

const PUBLIC_ENV_KEYS = new Set([
  "URL",
  "BASE_PATH",
  "SELF_URL",
  "CUSTOMER",
  "SHOP_API_URI",
  "BOOKING_API_URI",
  "MEMBERS_API_URI",
  "AUTH_API_URI",
  "MONITOR_API_URI",
  "CHECKOUT_URL",
  "POS_ID",
  "USE_BOOKING",
  "USE_COURSE",
  "USE_SESSION",
  "USE_ALLOTMENT",
  "USE_PRODUCT",
  "USE_ARTICLE_GROUP",
  "ENVIRONMENT",
  "NODE_ENV"
]);

/** Runtime/public config accessor (settings from config.json, then VITE_* fallbacks). */
export const publicEnv = new Proxy({} as Record<string, string | undefined>, {
  get(_target, prop: string) {
    if (typeof prop !== "string") return undefined;
    if (!PUBLIC_ENV_KEYS.has(prop)) return undefined;
    if (prop === "NODE_ENV") return import.meta.env.MODE;
    return getPublicEnv(prop);
  }
});
